import { array } from 'fp-ts';
export const formatMessage = (message, labels) => labels != null && array.isNonEmpty(labels) ? `[${labels.join('] [')}] ${message}` : message;
//# sourceMappingURL=formatMessage.js.map